import { useEffect } from 'react';
import useTranslate from '../../../Hooks/useTranslate';
import Input from '../../../Style-guide/Input';
import Textarea from '../../../Style-guide/Textarea';
import Schedule from '../schedule/schedule';
import CourtInputsWrapper from './styles/inputsWrapper';

const courtInputFields = (props) => {
  const {
    courtData,
    courtInputs,
    setCourtInputs,
    isSuccess,
    inputErrors,
    schedule,
    setSchedule,
  } = props;

  const tr = useTranslate();

  useEffect(() => {
    if (isSuccess && courtData) {
      setCourtInputs({
        name: courtData.name,
        address: courtData.address,
        contacts: courtData.contacts,
        description: courtData.description,
        maxDaysAheadToReserve: courtData.maxDaysAheadToReserve,
        priceForSixtyMin: courtData.priceForSixtyMin || '',
        priceForNinetyMin: courtData.priceForNinetyMin || '',
      });

      setSchedule(courtData.workingSchedule);
    }
  }, [courtData, isSuccess, setCourtInputs, setSchedule]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setCourtInputs((prevFields) => ({
      ...prevFields,
      [name]: value,
    }));
  };

  return (
    <CourtInputsWrapper>
      <div className='inputs-column'>
        <Input
          className='court-input'
          type='text'
          name='name'
          label={tr('court_name')}
          value={courtInputs.name}
          onChange={handleChange}
          autoComplete='off'
          error={inputErrors.name}
        />
        <Textarea
          className='court-input'
          name='address'
          label={tr('address')}
          value={courtInputs.address}
          onChange={handleChange}
          maxLength={200}
          autoComplete='street-address'
          error={inputErrors.address}
        />
        <Textarea
          className='court-input'
          name='contacts'
          label={tr('contact_details')}
          value={courtInputs.contacts}
          onChange={handleChange}
          maxLength={200}
          error={inputErrors.contacts}
        />
        <Textarea
          className='court-input'
          name='description'
          label={tr('description')}
          value={courtInputs.description}
          onChange={handleChange}
          maxLength={800}
          error={inputErrors.description}
        />
      </div>
      <div className='inputs-column numbers-column'>
        <Input
          className='court-input'
          type='number'
          step={1}
          hideButtons={false}
          min={1}
          max={180}
          name='maxDaysAheadToReserve'
          label={tr('max_days_ahead_to_reserve')}
          value={courtInputs.maxDaysAheadToReserve}
          onChange={handleChange}
          autoComplete='off'
          error={inputErrors.maxDaysAheadToReserve}
        />
        <Input
          className='court-input'
          type='number'
          step={1000}
          min={0}
          max={99000}
          name='priceForSixtyMin'
          label={tr('price_for_60_min')}
          value={courtInputs.priceForSixtyMin}
          onChange={handleChange}
          autoComplete='off'
          error={inputErrors.priceForSixtyMin}
        />
        <Input
          className='court-input'
          type='number'
          step={1000}
          min={0}
          max={99000}
          name='priceForNinetyMin'
          label={tr('price_for_90_min')}
          value={courtInputs.priceForNinetyMin}
          onChange={handleChange}
          autoComplete='off'
          error={inputErrors.priceForNinetyMin}
        />
      </div>

      <Schedule schedule={schedule} setSchedule={setSchedule} />
    </CourtInputsWrapper>
  );
};

export default courtInputFields;
